import React from "react";
import { normalizeText } from "../../../core/cimInterdicoes.utils";

function statusClassName(status) {
  return `status-${normalizeText(status).replace(/\s+/g, "-") || "neutro"}`;
}

export function PanelBlock({
  label,
  value,
  accent = false,
  muted = false,
  multiline = false,
  pending = false,
  wide = false,
}) {
  return (
    <div
      className={`interd-panelBlock${accent ?" interd-panelBlock--accent" : ""}${
        muted ?" is-muted" : ""
      }${wide ?" interd-panelBlock--wide" : ""}`}
    >
      <span className="interd-panelLabel">{label}</span>
      <strong
        className={[
          "interd-panelValue",
          multiline ?"interd-panelValue--multiline" : "",
          pending ?"interd-panelValue--pending" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {value}
      </strong>
    </div>
  );
}

export default function InterdicaoListaCardShell({ item, onOpen, layoutClassName, children }) {
  return (
    <button type="button" className="interd-listRow" onClick={() => onOpen(item)}>
      <div className="interd-listRail interd-listRail--lead">
        <span className="interd-codePill">{item.codigoUnico || item.id || "-"}</span>
      </div>

      <div className={layoutClassName}>{children}</div>

      <div className="interd-listRail interd-listRail--status">
        <span className={`interd-pill ${statusClassName(item.status)} is-vertical`}>
          {item.status || "-"}
        </span>
      </div>
    </button>
  );
}
